import { render, staticRenderFns } from "./PartnerAcademy.vue?vue&type=template&id=2225f9b7&scoped=true"
import script from "./PartnerAcademy.vue?vue&type=script&lang=js"
export * from "./PartnerAcademy.vue?vue&type=script&lang=js"
import style0 from "./PartnerAcademy.vue?vue&type=style&index=0&id=2225f9b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225f9b7",
  null
  
)

export default component.exports